export default {
  step1: '基本資訊',
  step2: '規格/價格資訊',
  step3: '禮品詳情',
  giftName: '禮品名稱',
  giftNameRequired: '請輸入禮品名稱',
  giftNamePlaceholder: '請輸入禮品名稱',
  giftType: '禮品類型',
  giftTypeRequired: '請選擇禮品類型',
  giftTypeTip: '禮品類型：實物禮品 虛擬禮品',
  physicalGift: '實物禮品',
  virtualGift: '虛擬禮品',
  giftCategory: '禮品分類',
  giftNo: '禮品編碼',
  giftNoRequired: '請輸入禮品編碼',
  giftNoPlaceholder: '請輸入禮品編碼',
  giftImage: '禮品圖片',
  imageRequired: '請上傳禮品圖片',
  giftValue: '禮品價值',
  valuePlaceholder: '請輸入禮品價值',
  productSpec: '產品規格',
  singleSpec: '單規格',
  multiSpec: '多規格',
  specNamePlaceholder: '規格名',
  addSpecValue: '新增',
  addSpecGroup: '+ 新增規格',
  generateSpecs: '+ 生成規格',
  specImage: '規格圖片',
  specPrice: '價格(元)',
  specStock: '庫存',
  specNo: '規格編號',
  specNoPlaceholder: '請輸入規格編號',
  specImageRequired: '規格圖片不能為空',
  specMatrixRequired: '請先生成規格矩陣',
  stockPlaceholder: '請輸入',
  editSpecName: '修改規格名稱',
  select: '選擇',
  giftDetail: '商品詳情',
  detailPlaceholder: '請輸入正文',
  phonePreview: '商品詳情',
  applySpecChanges: '確認修改',
};
